// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__VpayC","small":"Tab_small__u4fNB","medium":"Tab_medium__VfDuM","large":"Tab_large__4JKB4","active":"Tab_active__AoDsm","marker":"Tab_marker__54UUg"};